import moment from "@/helpers/moment";
import { dateUTC } from "@/helpers/date";

export default ({ schedule, term }) => {
  const {
    hasEndDate,
    calculatedValue,
    calculatedBy,
    Package,
    isCalculated
  } = term;
  var { startDate, startTime, endDate, endTime } = schedule;
  const price = Package.price;
  var start = null,
    end = null,
    total = null;

  if (startTime != null) {
    const min = startTime * 30;
    const hours = "0" + Math.floor(min / 60);
    const minutes = "0" + (min % 60);
    startTime = hours.slice(-2) + ":" + minutes.slice(-2);
  }
  if (endTime != null) {
    const min = endTime * 30;
    const hours = "0" + Math.floor(min / 60);
    const minutes = "0" + (min % 60);
    endTime = hours.slice(-2) + ":" + minutes.slice(-2);
  }
  if (startDate) {
    // start date, start time and end time
    if (hasEndDate && isCalculated && calculatedBy !== "hour") {
      start = moment(dateUTC(startDate + " " + startTime));
      end = startTime
        ? moment(dateUTC(startDate + " " + startTime)).add(
            calculatedValue,
            calculatedBy
          )
        : null;
    } else {
      start =
        startTime != null ? moment(dateUTC(startDate + " " + startTime)) : null;
      end =
        endDate && endTime != null
          ? moment(dateUTC(endDate + " " + endTime))
          : null;
    }
    total =
      end && start
        ? (end.diff(start, calculatedBy, true) / calculatedValue) * price
        : null;
  } else {
    total = price;
  }
  return {
    start: start && start.isValid() ? start : null,
    end: end && end.isValid() ? end : null,
    total
  };
};
